export class RequestForGuide {
  propertyId: string;
  propertyBookingId: string;
  guideId: string;
  language: string;
}
